(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-display"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Thumbnail navigation
  const thumbnails = document.querySelectorAll('.thumbnail-item');
  const mainImage = document.querySelector('.main-product-image');

  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const newSrc = this.querySelector('.thumbnail-image').src;
        mainImage.src = newSrc;
      });
    });
    thumbnails[0].classList.add('active');
  }

  // View More/Less features
  const viewMoreBtn = document.querySelector('.view-more-btn');
  const featuresList = document.querySelector('.features-list');

  if (viewMoreBtn && featuresList) {
    viewMoreBtn.addEventListener('click', function() {
      featuresList.classList.toggle('expanded');
      const isExpanded = featuresList.classList.contains('expanded');
      this.innerHTML = isExpanded 
        ? 'View Less <span class="arrow" style="transform: rotate(180deg);">▼</span>' 
        : 'View More <span class="arrow">▼</span>';
    });
  }

  // Wishlist toggle
  const wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function(e) {
      e.preventDefault();
      this.classList.toggle('active');
    });
  }

  // Delivery box modal
  const deliveryLink = document.querySelector('.delivery-link');
  const modal = document.querySelector('.delivery-box-modal');
  const closeBtn = document.querySelector('.delivery-box-modal-close');

  if (deliveryLink && modal) {
    deliveryLink.addEventListener('click', function(e) {
      e.preventDefault();
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', function() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    });

    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
});
// Swatch functionality
document.querySelectorAll('[data-swatch]').forEach(swatch => {
  swatch.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const container = this.closest('.custom-product-details');
    
    // Update active state
    container.querySelectorAll('[data-swatch]').forEach(s => s.classList.remove('active'));
    this.classList.add('active');
    
    // Update main image
    const variantImage = this.dataset.variantImage;
    const mainImage = document.querySelector('[data-product-image]');
    if (variantImage && mainImage) {
      mainImage.style.opacity = '0';
      setTimeout(() => {
        mainImage.src = variantImage;
        mainImage.style.opacity = '1';
      }, 150);
    }
    
    // Update price
    const price = this.dataset.variantPrice;
    const comparePrice = this.dataset.variantComparePrice;
    const priceElement = container.querySelector('[data-price]');
    const comparePriceElement = container.querySelector('[data-compare-price]');
    
    if (priceElement && price) {
      priceElement.textContent = '₹' + (price / 100).toFixed(2);
    }
    
    if (comparePriceElement && comparePrice) {
      comparePriceElement.textContent = '₹' + (comparePrice / 100).toFixed(2);
    }
    
    // Update variant ID in form
    const variantId = this.dataset.variantId;
    const variantInput = container.querySelector('[data-variant-input]');
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }
    
    // Update button availability
    const available = this.dataset.variantAvailable === 'true';
    const addToCartBtn = container.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.disabled = !available;
      addToCartBtn.textContent = available ? addToCartBtn.dataset.originalText || 'Add to Cart' : 'Sold Out';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
